import {ILocationSalesSubscription, SalesSubscriptionPostType} from "@chaosinsight/postoffice-portalclient"

export default class SubscriptionConfiguration {
	public isRegularEnabled: boolean = false
	public isLiveEnabled: boolean = false
	public readonly subscribers: number = 0

	public get isAnyEnabled(): boolean {
		return this.isRegularEnabled || this.isLiveEnabled
	}

	public get isAllEnabled(): boolean {
		return this.isRegularEnabled && this.isLiveEnabled
	}

	constructor(isRegularEnabled: boolean, isLiveEnabled: boolean, subscribers: number) {
		this.isRegularEnabled = isRegularEnabled
		this.isLiveEnabled = isLiveEnabled
		this.subscribers = subscribers
	}

	public toApi(): Pick<ILocationSalesSubscription, "IsEnabled" | "PostTypeId"> {
		return {
			IsEnabled: this.isRegularEnabled || this.isLiveEnabled,
			PostTypeId: this.isRegularEnabled
				? this.isLiveEnabled
					? SalesSubscriptionPostType.all
					: SalesSubscriptionPostType.regular
				: this.isLiveEnabled
					? SalesSubscriptionPostType.live
					: SalesSubscriptionPostType.all
		}
	}

	public clone(isRegularEnabled: boolean = this.isRegularEnabled, isLiveEnabled: boolean = this.isLiveEnabled): SubscriptionConfiguration {
		return new SubscriptionConfiguration(isRegularEnabled, isLiveEnabled, this.subscribers)
	}

	public static fromApi(data: ILocationSalesSubscription): SubscriptionConfiguration {
		return new SubscriptionConfiguration(
			data.IsEnabled && (data.PostTypeId === SalesSubscriptionPostType.regular || data.PostTypeId === SalesSubscriptionPostType.all),
			data.IsEnabled && (data.PostTypeId === SalesSubscriptionPostType.live || data.PostTypeId === SalesSubscriptionPostType.all),
			data.Subscribers
		)
	}
}
